export default function DevicesActivationsSingleModalController($scope, $filter, $uibModalInstance, products, productService, gettextCatalog) {

  'ngInject';

  $scope.productDetails = false;
  $scope.search = {
    text: ""
  };
  $scope.product = {};
  $scope.productsByPage = [];
  $scope.filteredProducts = [];

  //Pagination
  $scope.current = {
    productPage: 1
  };
  $scope.itemsPerPage = 4;
  $scope.maxSize = 1;

  //displayUserRolesByPage() is used to set the legnth of paging needed for filteredUserRoles.
  $scope.displayProductsByPage = function () {
    $scope.totalItems = $scope.filteredProducts.length;
    var begin = (($scope.current.productPage - 1) * $scope.itemsPerPage);
    var end = begin + $scope.itemsPerPage;
    $scope.productsByPage = $scope.filteredProducts.slice(begin, end);
    $scope.loading = false;
  };

  //Calls displayUserRolesByPage(), everytime the the user changes the page.
  $scope.pageChanged = function () {
    $scope.displayProductsByPage();
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredProducts = $filter('filter')($scope.products, $scope.search.text);
    $scope.displayProductsByPage();
  };

  $scope.selectedRow = undefined;
  $scope.setSelectedRow = function (id) {
    $scope.selectedRow = id;
  };

  $scope.predicate = 'name';
  $scope.reverse = true;
  $scope.order = function (predicate) {
    $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
    $scope.predicate = predicate;
  };

  $scope.products = products;
  $scope.filteredProducts = $scope.products.slice();
  $scope.displayProductsByPage();
  $scope.selectedProducts = false;
  $scope.packageName = '';
  $scope.update = function (id) {
    productService.getProductById(id).then(function (response) {
      $scope.product = response.data;
      if ($scope.product) {
        $scope.productDetails = true;
      }
    }, function (error) {
      var errorMsg = gettextCatalog.getString("Error retrieving product alert rules from the ONEi3 API ");
      if (error.data)
        errorMsg += ": " + (error.data.message ? error.data.message : error.data);
    });
  };

  $scope.ok = function () {
    $uibModalInstance.close($scope.product);
  };

  $scope.cancel = function () {
    $uibModalInstance.close('cancel');
  };

}